<proffeo-ui-dialog [title]="'company-projects.modals.edit-project-title' | translate">
  <mat-stepper
    #stepper
    [linear]="false"
    [disableRipple]="true"
  >
    <mat-step [completed]="form().valid()">
      <ng-template matStepLabel>
        <p class="text-sm text-proffeo-text">
          {{ 'company-projects.modals.project-first-step' | translate }}
        </p>
      </ng-template>
      <proffeo-project-basic-information [form]="form"></proffeo-project-basic-information>
    </mat-step>
  </mat-stepper>
  <div
    dialog-actions
    class="flex w-full justify-end items-center gap-2"
  >
    <proffeo-ui-button
      (clicked)="close()"
      [text]="'company-projects.modals.buttons-cancel' | translate"
      variant="primary"
    ></proffeo-ui-button>

    <div class="flex gap-2">
      @if (stepper.selectedIndex === 0) {
        <proffeo-ui-button
          (clicked)="saveProject()"
          [disabled]="form().submitting()"
          [text]="'company-projects.modals.buttons-save' | translate"
          variant="accent"
        ></proffeo-ui-button>
      } @else {
        <proffeo-ui-button
          (clicked)="stepper.previous()"
          [text]="'company-projects.modals.buttons-back' | translate"
          variant="secondary"
        ></proffeo-ui-button>
      }
      <!-- 
      <proffeo-ui-button
        variant="accent"
        fontIcon="arrow_forward"
        (clicked)="isLastStep() ? close() : stepper.next()"
        [text]="isLastStep() ? ('company-projects.modals.final-step-button' | translate)
        : ('company-projects.modals.buttons-next-step' | translate)
          "
      > 
      </proffeo-ui-button>-->
    </div>
  </div>
</proffeo-ui-dialog>
